// This function takes in an object and remove all property that has null value or empty string
export default function cleanObj(obj) {
    Object.keys(obj).forEach(key => (obj[key] === null || obj[key] === '') && delete obj[key]);
}
